module.exports = __webpack_public_path__ + "static/media/roma.05564850.png";